import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { WorkOrderBlockingMotive } from '@fullyops/data/work-order-blocking-motives/blocking-motives';
import { WorkOrderBlockingMotivesService } from '@fullyops/domain/work-order-blocking-motives/work-order-blocking-motives.service';
import { AutocompletingSelectComponent } from '@fullyops/shared/components/autocompleting-select/component';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextCapPipe, I18NextService } from 'angular-i18next';
import { map } from 'rxjs';

export interface BlockingMotiveSelection {
  motive: { id: string };
  notes: string;
}

@Component({
  selector: 'fo-blocking-motive-dialog',
  imports: [
    MaterialModule,
    ReactiveFormsModule,
    AutocompletingSelectComponent,
    I18NextCapPipe,
  ],
  templateUrl: './blocking-motive-dialog.component.html',
  styleUrl: './blocking-motive-dialog.component.scss',
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
})
export class BlockingMotiveDialogComponent implements OnInit, OnDestroy {
  constructor(
    private motiveService: WorkOrderBlockingMotivesService,
    private i18n: I18NextService,
  ) {}

  private order = new Intl.Collator(this.i18n.language, {
    sensitivity: 'accent',
  });

  protected motives$ = this.motiveService.motives$.pipe(
    map((ms) => [...ms].sort((a, b) => this.order.compare(a.name, b.name))),
  );

  protected form = new FormGroup({
    motive: new FormControl<WorkOrderBlockingMotive>(null),
    notes: new FormControl('', { nonNullable: true }),
  });

  ngOnInit(): void {
    this.motiveService.refresh();
  }

  ngOnDestroy(): void {
    this.motiveService.clear();
  }
}
